// extracted by mini-css-extract-plugin
export var OfficeList = "Office-module--OfficeList--129q3";
export var OfficeList__cont = "Office-module--OfficeList__cont--25Qgr";
export var OfficeList__ttl = "Office-module--OfficeList__ttl--2SXwx";
export var OfficeList__contChld = "Office-module--OfficeList__contChld--viaag";
export var OfficeList__sttl = "Office-module--OfficeList__sttl--iSTFG";
export var OfficeList__text = "Office-module--OfficeList__text--2DpPq";
export var OfficeList__map = "Office-module--OfficeList__map--3aztW";